module.exports = __webpack_public_path__ + "img/Character.5f16ea2f.svg";